/** Text size of the printed packlist (`?rozmiar=` of the PDF route). */
export const PDF_SIZES = [
  { value: 'maly', label: 'Mała' },
  { value: 'sredni', label: 'Średnia' },
  { value: 'duzy', label: 'Duża' },
] as const;
export type PdfSize = (typeof PDF_SIZES)[number]['value'];
const pdfSizeKey = (userId: string) => `packlists.pdfSize.${userId}`;

/** The person's last choice in this browser; storage may be unavailable (private mode), then medium. */
export function storedPdfSize(userId: string): PdfSize {
  try {
    const v = localStorage.getItem(pdfSizeKey(userId));
    return PDF_SIZES.some((s) => s.value === v) ? (v as PdfSize) : 'sredni';
  } catch {
    return 'sredni';
  }
}
export function storePdfSize(userId: string, size: PdfSize) {
  try {
    localStorage.setItem(pdfSizeKey(userId), size);
  } catch {
    // not remembered: the choice still works for this visit
  }
}

export const pdfUrl = (eventId: string, size: PdfSize) => `/api/packlists/${eventId}/pdf?rozmiar=${size}`;
